import { Link } from 'react-router-dom';
import WelcomeUser from '../../components/welcomeUser';
import './style.scss';

const dashboardItems = [
  {
    title: 'Gestionar usuarios',
    description: 'Crea usuarios, asigna roles y consulta su estado.',
    icon: 'manage_accounts',
    to: '/superadmin/usuarios'
  },
  {
    title: 'Plazos de firmas',
    description: 'Consulta los encuentros de cada grupo y ajusta el plazo de asistencia digital.',
    icon: 'edit_calendar',
    to: '/superadmin/plazos-firmas'
  },
  {
    title: 'Evidencias de incidencia',
    description: 'Visualiza y descarga las evidencias registradas en las acciones de incidencia.',
    icon: 'folder_open',
    to: '/superadmin/evidencias-incidencia'
  },
  {
    title: 'Bitácoras de cierre',
    description: 'Consulta y descarga en PDF las bitácoras de los grupos finalizados.',
    icon: 'menu_book',
    to: '/superadmin/bitacoras-cierre'
  },
  {
    title: 'Configuracion general',
    description: 'Espacio preparado para los parametros globales del sistema.',
    icon: 'settings',
    disabled: true
  },
  {
    title: 'Auditoria',
    description: 'Espacio preparado para consultar actividad y cambios.',
    icon: 'policy',
    disabled: true
  }
];

function SuperadminDashboard() {
  return (
    <section className='superadmin-dashboard'>
      <div className='superadmin-dashboard__content'>
        <WelcomeUser />
        <div className='superadmin-dashboard__heading'>
          <p className='superadmin-dashboard__eyebrow'>Administracion global</p>
          <h1>Panel Superadmin</h1>
          <p>Este es el punto de partida para gestionar la plataforma.</p>
        </div>

        <div className='superadmin-dashboard__grid'>
          {dashboardItems.map(item => {
            const content = (
              <>
                <span className='material-symbols-rounded' aria-hidden='true'>
                  {item.icon}
                </span>
                <div>
                  <h2>{item.title}</h2>
                  <p>{item.description}</p>
                </div>
                {!item.disabled && (
                  <span className='material-symbols-rounded superadmin-dashboard__arrow'>
                    arrow_forward
                  </span>
                )}
                {item.disabled && <span className='superadmin-dashboard__soon'>Proximamente</span>}
              </>
            );

            return item.disabled ? (
              <article key={item.title} className='superadmin-dashboard__card superadmin-dashboard__card--disabled'>
                {content}
              </article>
            ) : (
              <Link key={item.title} to={item.to} className='superadmin-dashboard__card'>
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default SuperadminDashboard;
